// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1oTvm","text":"SelectPayment_text__1axl-","title":"SelectPayment_title__Ds86y","btn":"SelectPayment_btn__3NB2W"};